// extracted by mini-css-extract-plugin
export default {"headerTitle":"parsers_headerTitle__WT76j","page":"parsers_page__gT-8j","header":"parsers_header__reDza"};